
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexep6affdAyX4yIsmJWgv5Pl14cesOuAYw45oAPvKHMlAMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/index.vue?macro=true";
import { default as loginzFGgmP3ePNtXA4gte9PHNrEpVHkGE_QT4LMOhzEe_78Meta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/login.vue?macro=true";
import { default as termslc_rwWyRUkxUbpBO_Jw794xEKZILMfZOyuybT9n6YbMMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/terms.vue?macro=true";
import { default as editorOnKs97zRnqNOX92TrJ4RWeeTTZZChGDAFGeiJIt1Df4Meta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/editor.vue?macro=true";
import { default as signup6cdNhQPnKxtDIPIaVbSWnISphMS6WbQqx5z85Y8xLlsMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/signup.vue?macro=true";
import { default as profileYxRIzFhhL4r2j9MkzrAdCipFAjX6AK8wGV6FxfCuHgEMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/profile.vue?macro=true";
import { default as indexenO4UtafVv64Z8Q9usOBwJwkyZiYBcS7bqrl2lGOCRcMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/index.vue?macro=true";
import { default as sharevipXgoZ2dnGdEuG6aQlU8DBkrE5yZ8gqeiB15QPnsgEMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/share.vue?macro=true";
import { default as prizesSsFm_I3DJOz0AvwSrGvJoJm54d6Lp1cxhiYNJZ9R3OUMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/prizes.vue?macro=true";
import { default as membersOgpFWsW0yg_nlCjIY6znXtmjeveJVlR7DSwMrE_J52MMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/members.vue?macro=true";
import { default as partnersgwQ46fRIUIPZAOwVveq9ExteYSJHRCLOkHSE3mnFr8AMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/partners.vue?macro=true";
import { default as settings9rUsmil4G5ASNFtTra0WAA_jBEpH9CdC6Z_gc_2bS0UMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/settings.vue?macro=true";
import { default as mailchimpmIN9Wp9WtIwz2I3lumvQj6USX10v_tFxfYB3Tgni6UsMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/mailchimp.vue?macro=true";
import { default as new4_h_UsxXoNzUQwVsS8DzS8wv8RHW9Q_m8_3n3CuL06IMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/tiers/new.vue?macro=true";
import { default as indexIjfGoIXIGOVo_X_FU6rIZE8ErEDERDZL_wNEzqAhI6oMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/tiers/index.vue?macro=true";
import { default as new4fSMiZ8sHm13njlwVYV_JcBEpTsnNGHsq_5E6XJLby8Meta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/updates/new.vue?macro=true";
import { default as index6xTpW4N9pHVcO7idF50pFqxHjZy0lmq8RAJx4f5ly_EMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/integrations/index.vue?macro=true";
import { default as klaviyoolB7NtGOZaOogM_WojeCssNoqMDgF9eLoPt0nVB4M3kMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/integrations/klaviyo.vue?macro=true";
import { default as integrationsyHSqFZXQznzGQvhfziG9riF0BBrKyW6aiAETednHZkAMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/integrations.vue?macro=true";
import { default as _91slug_935WjlTNPvD7JexnUCjWatZAc7U_KVkgAu7KgUu2YQ_C0Meta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/tiers/[slug].vue?macro=true";
import { default as newKaOrSAMjwpXwWOZ35VYQ_3tH4IwchelDhXxg8GJDY_oMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/giveaways/new.vue?macro=true";
import { default as indexOZp55p0kJnZHBlvHQflXhCBct1rvG5qMme7GEugs2YsMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/updates/index.vue?macro=true";
import { default as _91id_93q_HGggmhJ0cOBOFb4WXufAJ_ZqdwpTdK8IbQAiqglCYMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/campaigns/[id].vue?macro=true";
import { default as _91slug_93ZErouuxtN92EyjPnpbcaoifuZkuILs4I6uZEUpEV_Q4Meta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/updates/[slug].vue?macro=true";
import { default as indexO0jBm1OgiIJAXArGil_7PlWawwfs5QaKLvvWL7zA5hgMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/campaigns/index.vue?macro=true";
import { default as indexfR8yozluegkNdyTzCPcn7ivKdHT3CDGB3V1eB7tFXlAMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/giveaways/index.vue?macro=true";
import { default as create_UloKf6jpGlCHcHLnUhIxA0mqNWcDmyZOWhRrGIGMkQMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/campaigns/create.vue?macro=true";
import { default as new_45pollkQ_MDk8C7Cn0sciY_xfoQEwbkmlVdj9FhGce_bnJAGoMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/updates/new-poll.vue?macro=true";
import { default as _91id_93PKA_ahzYXSwGNveODTFdrXuXliThqVP9ENOeZS9skKIMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/giveaways/edit/[id].vue?macro=true";
import { default as newZcrfNLBN5w92fYTvvJ_Wyzr8LkibT8olqOIfGdqZSRYMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/giveaways/prizes/new.vue?macro=true";
import { default as _91id_93TxfkOq4LZWqPOJL2MMPN_SHWB5uofYv7xGRjH_HY3zcMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/giveaways/prizes/edit/[id].vue?macro=true";
import { default as dashboard_ibZ15B0V8JsW7byF4T4VuQ1xS7VpJZpd5HOlKhQltIMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard.vue?macro=true";
import { default as loginWr5ewKVa3VHHPKU0x51bitKOsxF5PpGqEd4lNtU_cF4Meta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/donor/login.vue?macro=true";
import { default as reset_45passwordCNkVTkw3LQsQBOZDOCumGgHOJAw8wLzLfAMkWNYhIKQMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/reset-password.vue?macro=true";
import { default as forgot_45passwordqROUK3alMj15RxtrrsIJy9JLWdqhQji4Wf4YH3r91ncMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/forgot-password.vue?macro=true";
import { default as callbackM4stBElOZN_l_O1jf5_3n2BBV_Qm2Dv8R6YbKHEw5XYMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/stripe/callback.vue?macro=true";
import { default as joincIh2Tjn1ovy_Aeu6vaEA8nNTEtVQYQyhSOwPHD_ZJtQMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/join.vue?macro=true";
import { default as indexDoKKZ_P_xuIvr6g9rlPyx19ECjuf70KJdizWwAJTxrMMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/index.vue?macro=true";
import { default as checkoutjpdu2Z6aq0_Gn7am69fr8IH1D6mpnyNoVkOExb_kJWQMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/checkout.vue?macro=true";
import { default as impact_45feedm1fRiCid7GmmVCBc3Sbw7uScfM7mAJS68QvdHt7mmcEMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/impact-feed.vue?macro=true";
import { default as our_45partners9w4utDyJjiRhETLk6HNLYyXE0evH_KjFISP1F1P4SlMMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/our-partners.vue?macro=true";
import { default as indexrxABSPqcsfYa4eWcdR4xevtJkpob_zWaJ1mA_xylsvIMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/welcome/index.vue?macro=true";
import { default as indexX6MQ3_wYM3fKaWP1FpmMvtWGkER8afwdJ6_H2lTzhqsMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/giveaways/index.vue?macro=true";
import { default as rulesyFk_bUzouBEBR6pA5adcYpUGzYfYUdw4xO6uEWAaKssMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/giveaways/rules.vue?macro=true";
import { default as donateXWGEtnDdmfoH2FfXGsLNiByvizavsHKCyJ027dvAPzAMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/partners/[partnerSlug]/donate.vue?macro=true";
import { default as _91slug_935RWTXyoBQvB319JU2qM6MxfMHdsdYIoqkhAsKmeGuywMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug].vue?macro=true";
import { default as indexEfGCeXVUGpw4a3ev9xtEh0ZIvfDQS3mKrxcoDMicuUQMeta } from "/vercel/path0/packages/ddc-giving-circle/app/pages/mailchimp/redirect/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/terms.vue")
  },
  {
    name: "editor",
    path: "/editor",
    meta: { ...(editorOnKs97zRnqNOX92TrJ4RWeeTTZZChGDAFGeiJIt1Df4Meta || {}), ...{"middleware":["require-staff"]} },
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/editor.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/signup.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: { ...(profileYxRIzFhhL4r2j9MkzrAdCipFAjX6AK8wGV6FxfCuHgEMeta || {}), ...{"middleware":"authenticated-donor"} },
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/profile.vue")
  },
  {
    name: dashboard_ibZ15B0V8JsW7byF4T4VuQ1xS7VpJZpd5HOlKhQltIMeta?.name,
    path: "/dashboard",
    meta: { ...(dashboard_ibZ15B0V8JsW7byF4T4VuQ1xS7VpJZpd5HOlKhQltIMeta || {}), ...{"middleware":["require-staff"]} },
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard.vue"),
    children: [
  {
    name: "dashboard",
    path: "",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-share",
    path: "share",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/share.vue")
  },
  {
    name: "dashboard-prizes",
    path: "prizes",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/prizes.vue")
  },
  {
    name: "dashboard-members",
    path: "members",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/members.vue")
  },
  {
    name: "dashboard-partners",
    path: "partners",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/partners.vue")
  },
  {
    name: "dashboard-settings",
    path: "settings",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/settings.vue")
  },
  {
    name: "dashboard-mailchimp",
    path: "mailchimp",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/mailchimp.vue")
  },
  {
    name: "dashboard-tiers-new",
    path: "tiers/new",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/tiers/new.vue")
  },
  {
    name: "dashboard-tiers",
    path: "tiers",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/tiers/index.vue")
  },
  {
    name: "dashboard-updates-new",
    path: "updates/new",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/updates/new.vue")
  },
  {
    name: integrationsyHSqFZXQznzGQvhfziG9riF0BBrKyW6aiAETednHZkAMeta?.name,
    path: "integrations",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/integrations.vue"),
    children: [
  {
    name: "dashboard-integrations",
    path: "",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/integrations/index.vue")
  },
  {
    name: "dashboard-integrations-klaviyo",
    path: "klaviyo",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/integrations/klaviyo.vue")
  }
]
  },
  {
    name: "dashboard-tiers-slug",
    path: "tiers/:slug()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/tiers/[slug].vue")
  },
  {
    name: "dashboard-giveaways-new",
    path: "giveaways/new",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/giveaways/new.vue")
  },
  {
    name: "dashboard-updates",
    path: "updates",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/updates/index.vue")
  },
  {
    name: "dashboard-campaigns-id",
    path: "campaigns/:id()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/campaigns/[id].vue")
  },
  {
    name: "dashboard-updates-slug",
    path: "updates/:slug()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/updates/[slug].vue")
  },
  {
    name: "dashboard-campaigns",
    path: "campaigns",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/campaigns/index.vue")
  },
  {
    name: "dashboard-giveaways",
    path: "giveaways",
    meta: indexfR8yozluegkNdyTzCPcn7ivKdHT3CDGB3V1eB7tFXlAMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/giveaways/index.vue")
  },
  {
    name: "dashboard-campaigns-create",
    path: "campaigns/create",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/campaigns/create.vue")
  },
  {
    name: "dashboard-updates-new-poll",
    path: "updates/new-poll",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/updates/new-poll.vue")
  },
  {
    name: "dashboard-giveaways-edit-id",
    path: "giveaways/edit/:id()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/giveaways/edit/[id].vue")
  },
  {
    name: "dashboard-giveaways-prizes-new",
    path: "giveaways/prizes/new",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/giveaways/prizes/new.vue")
  },
  {
    name: "dashboard-giveaways-prizes-edit-id",
    path: "giveaways/prizes/edit/:id()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/dashboard/giveaways/prizes/edit/[id].vue")
  }
]
  },
  {
    name: "donor-login",
    path: "/donor/login",
    meta: loginWr5ewKVa3VHHPKU0x51bitKOsxF5PpGqEd4lNtU_cF4Meta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/donor/login.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/reset-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/forgot-password.vue")
  },
  {
    name: "stripe-callback",
    path: "/stripe/callback",
    meta: {"middleware":["require-staff"]},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/stripe/callback.vue")
  },
  {
    name: _91slug_935RWTXyoBQvB319JU2qM6MxfMHdsdYIoqkhAsKmeGuywMeta?.name,
    path: "/subdomain/:slug()",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug].vue"),
    children: [
  {
    name: "subdomain-slug-join",
    path: "join",
    meta: joincIh2Tjn1ovy_Aeu6vaEA8nNTEtVQYQyhSOwPHD_ZJtQMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/join.vue")
  },
  {
    name: "subdomain-slug",
    path: "",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/index.vue")
  },
  {
    name: "subdomain-slug-checkout",
    path: "checkout",
    meta: checkoutjpdu2Z6aq0_Gn7am69fr8IH1D6mpnyNoVkOExb_kJWQMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/checkout.vue")
  },
  {
    name: "subdomain-slug-impact-feed",
    path: "impact-feed",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/impact-feed.vue")
  },
  {
    name: "subdomain-slug-our-partners",
    path: "our-partners",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/our-partners.vue")
  },
  {
    name: "subdomain-slug-welcome",
    path: "welcome",
    meta: {"middleware":"authenticated-donor"},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/welcome/index.vue")
  },
  {
    name: "subdomain-slug-giveaways",
    path: "giveaways",
    meta: indexX6MQ3_wYM3fKaWP1FpmMvtWGkER8afwdJ6_H2lTzhqsMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/giveaways/index.vue")
  },
  {
    name: "subdomain-slug-giveaways-rules",
    path: "giveaways/rules",
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/giveaways/rules.vue")
  },
  {
    name: "subdomain-slug-partners-partnerSlug-donate",
    path: "partners/:partnerSlug()/donate",
    meta: donateXWGEtnDdmfoH2FfXGsLNiByvizavsHKCyJ027dvAPzAMeta || {},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/subdomain/[slug]/partners/[partnerSlug]/donate.vue")
  }
]
  },
  {
    name: "mailchimp-redirect",
    path: "/mailchimp/redirect",
    meta: {"middleware":["require-staff"]},
    component: () => import("/vercel/path0/packages/ddc-giving-circle/app/pages/mailchimp/redirect/index.vue")
  }
]